const INITIAL_STATE = {
  data: {}, 
  tickets: {},
  report:{}, 
  errors: {}
}
                  
const cancellationReport = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_CANCELLATION_REPORT_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, report: action.data }
  case 'GET_CANCELLATION_REPORT_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
            
export default cancellationReport;